export default "__VITE_ASSET__B7V6l8ZH__"